<template>
    <div class="create-project">
        <div class="container-fluid">

            <div class="row justify-content-center align-items-center">
                <div class="col-md-6 order-md-last">

                    <div class="form-group">
                        <label for="project-name">Project Name</label>
                        <input type="text"
                               id="project-name"
                               class="form-control form-control-lg"
                               placeholder="Name the Change Project" v-model="project.name">

                        <div class="text-danger small">{{ utils.errors(errors, 'name').join(', ') }}</div>
                    </div>

                    <div class="form-group">
                        <label for="project-name">Classroom</label>
                        <input type="text"
                               id="project-classroom"
                               class="form-control form-control-lg"
                               placeholder="Name the classroom" v-model="project.classroom">

                        <div class="text-danger small">{{ utils.errors(errors, 'classroom').join(', ') }}</div>
                    </div>

                    <div class="form-group">
                        <label for="project-organization">Organization</label>
                        <select id="project-organization"
                                class="form-control"
                                v-model="project.organization_id">
                            <option :value="null">Personal Project</option>
                            <option v-for="org in organizations" :key="org.id" :value="org.id">{{ orgLabel( org ) }}</option>
                        </select>

                        <div class="text-danger small">{{ utils.errors(errors, 'organization_id').join(', ') }}</div>

                    </div>

                </div>
                <div class="col-md-5 order-md-first" v-if="has_selectable_podcast_section">
                    <div>
                        <label>Available Podcast Sections</label>
                        <div class="row">
                            <div class="col-md-12" v-for="ps in path.empty_podcast_sections" :key="ps.selected">
                                <div class="card mb-3">
                                    <div class="card-body">
                                        <h5 class="mb-2 font-weight-normal">
                                            <strong>{{ ps.stage.name }}</strong> /
                                            <span>{{ [ps.section.name, ps.section.description].join(' - ') }}</span>
                                        </h5>
                                        <podcast-selector class="podcast-selector" v-model="ps.selected" @change="podcastSelectionChanged()" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import utils from "@/mixins/utils";
import themes from "@/DATA/themes";
import API from "@/API";
import {mapActions} from "vuex";
import PodcastSelector from "@/Components/Common/PodcastSelector";

export default {
    name: "CreateProject",
    components: {PodcastSelector},
    props: ['errors', 'value', 'organizations', 'path_id', 'podcast_short_name'],
    emits: ['update'],
    mixins: [utils],

    data(){
        return {

            selected: null,

            themes,
            project: {
                organization_id: null,
                name: '',
                theme: '',
                classroom: '',
                podcasts: [],
            },
            path: {
                info: null,
                repo: null,
                available_podcasts: [],
                empty_podcast_sections: [],
            },
        }
    },


    computed: {
        has_selectable_podcast_section(){
            return !!this.podcast_short_name && this.path?.empty_podcast_sections?.length > 0;
        }
    },

    watch: {
        project: {
            deep: true,
            handler(project){
                this.$emit('update', {...project});
            }
        },
    },


    methods: {

        ...mapActions('repositories', {
            repo: 'getRepository',
        }),



        orgLabel(org){
            let label = org.name;
            if( org.meta?.address ){
                label += ', ' + org.meta.address;
            }
            return label;
        },

        podcastSelectionChanged(){

            console.log('selection changed');

            this.project.podcasts = this.path.empty_podcast_sections
                .filter(p => p.selected)
                .map(p => ({
                    key: `stage_${p.stage.id}_${p.section.id}_podcast_${p.element.id}`,
                    val: { podcast: {id: p.selected.id, short_name: p.selected.short_name} },
                }));
        },

        async initPodcasts(){

            // Setup empty podcast sections.

            let c_elements = [];
            const fgs = this.path?.repo?.fragments;

            for( const i in fgs.stages ){
                if( !fgs.stages.hasOwnProperty(i) ) continue;
                const stage = fgs.stages[i];
                const stage_info = fgs[`stage_${stage}_config`];
                const sections = fgs[`stage_${stage}_activity_sections`];
                if( typeof sections === 'undefined' ) continue;

                for( const j in sections ){
                    if( !sections.hasOwnProperty(j) ) continue;
                    const section = sections[j];
                    const activities = fgs[`stage_${stage}_combined_activities_${section.id}`];
                    if( typeof activities === 'undefined' ) continue;

                    c_elements = c_elements.concat(activities.map(element => ({
                        stage: {id: stage, ...stage_info},
                        section,
                        element,
                        podcast: typeof fgs[`stage_${stage}_${section.id}_podcast_${element.id}`] !== 'undefined'
                            ? fgs[`stage_${stage}_${section.id}_podcast_${element.id}`]
                            : null,
                        selected: null,
                    })));
                }
            }

            const elements = await API.elements.bulk({ids: c_elements.map(e => e.element.v)});
            const podcasts = elements.filter(e => (e.type === 'resource' && e.data?.type === 'podcast'));
            this.path.empty_podcast_sections = c_elements
                .filter(ce => (!ce.podcast && podcasts.find(p => (p.id + '') === (ce.element.v + ''))));

            if( this.path.empty_podcast_sections.length && this.podcast_short_name ){
                this.path.empty_podcast_sections[0].selected = await API.podcasts.get( this.podcast_short_name );
                this.podcastSelectionChanged();
            }

            this.$forceUpdate();

        }
    },

    async mounted() {

        if( this.value ){
            this.project = this.value;
        }

        if( this.organizations.length ){
            this.project.organization_id = this.organizations[0]?.id;
        }else{
            this.project.organization_id = null;
        }

        this.project.editable_by = 'admin'

        if( this.path_id ){

            this.path.info = await API.learning_paths.get(this.path_id);
            this.path.repo = await this.repo({
                name: API.fragments.SCOPE_LEARNING_PATH,
                id: this.path_id
            });

            await this.initPodcasts();
        }

    },

}
</script>

<style lang="scss" scoped>
.podcast-selector{
    // margin-left: -1rem;
}
</style>
